import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    FaTicketAlt,
    FaQrcode,
    FaUsers,
    FaMobileAlt,
    FaGooglePlay,
    FaApple,
    FaShieldAlt,
    FaCreditCard,
    FaLock,
    FaUniversity,
    FaUndoAlt,
} from "react-icons/fa";
import { IoPerson, IoMailSharp } from "react-icons/io5";
import { BsDot } from "react-icons/bs";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ChatbotIcon from "../components/ChatbotIcon";
import EventsHome from "../components/EventsHome";
import { contact } from "../services/LoginService";

// Visuels existants (remplace-les par des captures de l'app quand tu les as)
import video from "../assets/images_assoc/vid1.mp4";


import SectionDon from "../components/SectionDon";


import img1 from "../assets/newimgs/1.png"
import img2 from "../assets/newimgs/2.png"
import img3 from "../assets/newimgs/3.png"
import img4 from "../assets/newimgs/4.png"
import img5 from "../assets/newimgs/5.png"
import img6 from "../assets/newimgs/6.png"
/* ==================================================
   BLOCS IMAGE / TEXTE (alternés gauche / droite)
================================================== */

const blocs = [
    {
        titre: "Notre but : faire rayonner vos événements",
        texte:
            "Thrundrz est né pour une raison simple : aider les organisateurs, artistes et collectifs à remplir leurs événements. Nous réunissons en un seul endroit tout ce qu'il faut pour publier, vendre et faire connaître vos événements auprès du public local.",
        points: [
            "Une plateforme pensée pour les créateurs",
            "Une visibilité réelle auprès du public de votre région",
            "Un accompagnement humain à chaque étape",
        ],
        img: img1,
    },
    {
        titre: "Gérez votre billetterie en ligne",
        texte:
            "Vendez vos billets directement sur Thrundrz. Créez plusieurs tarifs, proposez des événements gratuits ou payants et suivez vos ventes en temps réel depuis votre espace créateur.",
        points: [
            "Tarifs multiples : adulte, enfant, réduit…",
            "Événements gratuits ou payants",
            "Suivi de vos ventes depuis votre espace",
        ],
        img: img2,
    },
    {
        titre: "QR codes et contrôle des entrées",
        texte:
            "Chaque billet dispose de son QR code unique. Le jour J, vous scannez les billets à l'entrée et vous savez exactement qui est arrivé. Fini les listes papier et les billets en double.",
        points: [
            "Un QR code unique par billet",
            "Scan rapide à l'entrée de l'événement",
            "Suivi des entrées et billets déjà utilisés",
        ],
        img: img3,
    },
    {
        titre: "Boostez vos événements grâce à la communauté",
        texte:
            "Vos événements apparaissent dans l'application Thrundrz, auprès d'une communauté qui cherche ses prochaines sorties. Le public les découvre, les like, les partage… et vient les vivre.",
        points: [
            "Visibilité dans l'app iOS et Android",
            "Likes et partages qui font circuler vos événements",
            "Échanges avec votre public via la messagerie",
        ],
        img: img4,
    },
    {
        titre: "Organisez-vous en équipe",
        texte:
            "Un événement, c'est rarement une seule personne. Invitez vos collaborateurs dans votre espace pour gérer ensemble les événements, la billetterie et l'accueil du public.",
        points: [
            "Invitez les membres de votre équipe",
            "Répartissez la gestion de vos événements",
            "Tout le monde travaille sur les mêmes infos",
        ],
        img: img5,
    },
    {
        titre: "Pilotez tout depuis votre espace créateur",
        texte:
            "Publiez, modifiez et dupliquez vos événements en quelques clics. Affiches, infos pratiques, artistes, lieu et horaires : tout est centralisé dans un tableau de bord clair.",
        points: [
            "Publication en quelques clics",
            "Agenda de tous vos événements",
            "Modification à tout moment",
        ],
        img: img6,
    },
];

/* ==================================================
   PAIEMENTS SÉCURISÉS — comment l'organisateur est payé
================================================== */

const etapesPaiement = [
    {
        icon: FaCreditCard,
        titre: "Le public paie son billet",
        texte: "Paiement par carte, sécurisé par Stripe. Thrundrz ne voit jamais les données bancaires.",
    },
    {
        icon: FaLock,
        titre: "Stripe conserve l'argent",
        texte: "Les fonds restent chez Stripe, établissement agréé. Ils ne passent jamais par le compte bancaire de Thrundrz.",
    },
    {
        icon: FaShieldAlt,
        titre: "Thrundrz prend uniquement un pourcentage",
        texte: "Nos frais de service sont un simple pourcentage, et c'est tout. Aucun abonnement caché.",
    },
    {
        icon: FaUniversity,
        titre: "Vous êtes payé sur votre RIB",
        texte: "Votre part est versée automatiquement entre 7 et 15 jours après la date de votre événement.",
    },
];

const garantiesPaiement = [
    "Votre propre compte de paiement Stripe, vérifié par Stripe",
    "Vos montants à venir et vos virements visibles en direct",
    "Versement automatique, sans démarche de votre part",
    "Des règles claires, écrites dans nos conditions générales",
];

const avantages = [
    { icon: FaTicketAlt, label: "Billetterie en ligne" },
    { icon: FaQrcode, label: "QR codes à l'entrée" },
    { icon: FaUsers, label: "Communauté Thrundrz" },
    { icon: FaMobileAlt, label: "App iOS & Android" },
    { icon: FaShieldAlt, label: "Paiements sécurisés Stripe" },
];

const faq = [
    {
        q: "Comment publier mon premier événement ?",
        r: "Créez votre espace créateur depuis « Devenir partenaire », puis allez dans « Mes événements » et cliquez sur « Ajouter ». Renseignez l'affiche, la date, le lieu et les tarifs : votre événement est en ligne.",
    },
    {
        q: "Quels sont vos tarifs ?",
        r: "Pour toute question sur les tarifs et les conditions de la billetterie, contactez-nous via le formulaire en bas de cette page : notre équipe vous répond rapidement.",
    },
    {
        q: "Quand est-ce que je reçois mon argent ?",
        r: "Votre part est versée automatiquement entre 7 et 15 jours après la date de votre événement, via Stripe Connect, sur votre compte bancaire. Exemple : pour un événement le 30 septembre, le versement part au plus tard le 15 octobre.",
    },
    {
        q: "Thrundrz touche-t-il à mon argent ?",
        r: "Non. L'argent des billets est encaissé et conservé par Stripe, établissement de paiement agréé, et ne passe jamais par le compte bancaire de Thrundrz. Nous prenons uniquement un pourcentage, puis votre part vous est versée.",
    },
    {
        q: "Comment j'active mes paiements ?",
        r: "Depuis « Ma Billetterie », cliquez sur « Activer mes paiements ». Stripe vous demande vos informations et votre RIB en toute sécurité ; Thrundrz ne voit jamais votre IBAN complet.",
    },
    {
        q: "Et si mon événement est annulé ?",
        r: "Si vous annulez votre événement, les acheteurs sont remboursés à 100 %. Comme l'argent est encore chez Stripe tant que le versement n'est pas parti, le remboursement est simple et rapide. Les règles sont détaillées dans nos conditions générales.",
    },
    {
        q: "Un acheteur peut-il annuler son billet ?",
        r: "Oui, depuis l'application, jusqu'à 24 h avant l'événement. Il est remboursé du prix de son billet ; seuls nos frais de service et les frais de paiement ne sont pas remboursés. Il peut aussi, dans le même délai, donner sa place à quelqu'un d'autre en changeant le nom sur le billet.",
    },
    {
        q: "Puis-je proposer plusieurs tarifs ?",
        r: "Oui. Vous pouvez créer plusieurs tarifs pour un même événement (adulte, enfant, réduit…) ou le déclarer gratuit.",
    },
    {
        q: "Comment fonctionnent les QR codes ?",
        r: "Chaque billet a un QR code unique. À l'entrée, vous le scannez pour valider le billet ; un billet déjà scanné est signalé.",
    },
    {
        q: "Où apparaissent mes événements ?",
        r: "Sur le site Thrundrz et dans l'application mobile, disponible sur iOS et Android, auprès du public de votre région.",
    },
    {
        q: "Mon équipe peut-elle m'aider à gérer ?",
        r: "Oui, depuis « Mon équipe » vous invitez vos collaborateurs pour gérer vos événements avec vous.",
    },
    {
        q: "Je suis bloqué, qui peut m'aider ?",
        r: "Notre équipe est disponible : écrivez-nous via le formulaire en bas de cette page, nous revenons vers vous rapidement.",
    },
];

/* ==================================================
   PAGE
================================================== */

const MindHome = () => {
    const [form, setForm] = useState({ nom: "", prenom: "", email: "", message: "" });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const result = await contact(form);
            if (result.success) {
                toast.success(result.message, { position: "top-right", autoClose: 5000 });
                setForm({ nom: "", prenom: "", email: "", message: "" });
            } else {
                toast.error(result.message, { position: "top-right", autoClose: 5000 });
            }
        } catch (err) {
            toast.error("Erreur inattendue lors de l'envoi.", { position: "top-right", autoClose: 5000 });
        } finally {
            setIsLoading(false);
        }
    };

    /* ---------- Styles communs (mobile-first) ---------- */

    // Conteneur de 2 boutons : colonne pleine largeur sur téléphone, ligne dès sm
    const btnGroup = "flex flex-col sm:flex-row w-full sm:w-auto gap-3 sm:gap-4";

    // Taille des boutons : petite sur téléphone, normale dès sm
    const btnBase =
        "w-full sm:w-auto text-center text-sm sm:text-base font-semibold px-5 sm:px-8 py-2.5 sm:py-3 rounded-full transition-colors";

    // text-base sur mobile = 16px → évite le zoom automatique d'iOS sur les champs
    const inputClass =
        "w-full pl-10 pr-4 py-2.5 sm:py-3 text-base sm:text-sm text-black bg-white rounded-lg border border-violet-300 focus:border-violet-600 focus:ring-violet-600 outline-none placeholder:text-violet-400";

    return (
        <>
            <Helmet>
                <title>Thrundrz — Billetterie, QR codes et visibilité pour les organisateurs d'événements</title>
                <meta
                    name="description"
                    content="Organisateurs, artistes, collectifs : gérez votre billetterie, vos QR codes et vos événements, et boostez-les grâce à la communauté Thrundrz."
                />
                <link rel="canonical" href="https://thrundrz.fr/" />
            </Helmet>

            <Navbar />

            <main className="w-full overflow-x-hidden bg-black text-white font-Poppins lg:pt-12 pt-5">

                {/* ==================================================
                    1. HERO — texte gauche / vidéo droite
                ================================================== */}

                <section className="relative w-full overflow-hidden px-4 sm:px-8 2xl:px-20 pt-16 pb-10 sm:pt-20 sm:pb-16 lg:pt-28 lg:pb-24">
                    <div className="pointer-events-none absolute -top-32 -left-32 w-[300px] h-[300px] sm:w-[600px] sm:h-[600px] rounded-full bg-violet-700/25 blur-[100px] sm:blur-[140px]" />

                    <div className="relative max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
                        <div className="w-full lg:w-1/2 flex flex-col items-start gap-4 sm:gap-6">
                            <p className="text-xs sm:text-base font-semibold uppercase tracking-[0.15em] sm:tracking-[0.2em] text-violet-400">
                                Espace créateurs d'événements
                            </p>

                            <h1 className="font-archivo leading-tight tracking-wide text-[1.75rem] sm:text-5xl xl:text-6xl">
                                Vos événements, votre billetterie, votre public.{" "}
                                <span className="text-violet-400">Réunis en un seul endroit.</span>
                            </h1>

                            <p className="text-sm sm:text-lg lg:text-xl text-white/80 leading-relaxed">
                                Publiez vos événements, vendez vos billets, scannez les QR codes
                                à l'entrée et touchez la communauté Thrundrz.
                            </p>

                            <div className={`${btnGroup} mt-1 sm:mt-2`}>
                                <a
                                    href="/devenir-partenaire#login"
                                    className={`${btnBase} bg-violet-600 hover:bg-violet-700 text-white`}
                                >
                                    Créer mon espace créateur
                                </a>
                                <a
                                    href="#contact"
                                    className={`${btnBase} border border-white/30 hover:border-violet-400 hover:text-violet-300`}
                                >
                                    Contactez-nous
                                </a>
                            </div>
                        </div>

                        <div className="w-full lg:w-1/2">
                            <video
                                src={video}
                                autoPlay
                                muted
                                loop
                                playsInline
                                className="w-full h-[32vh] sm:h-[45vh] lg:h-[60vh] object-cover rounded-xl sm:rounded-2xl shadow-2xl shadow-violet-900/40"
                            />
                        </div>
                    </div>
                </section>

                {/* ==================================================
                    2. BLOCS ALTERNÉS IMAGE / TEXTE
                ================================================== */}

                <section className="w-full px-4 sm:px-8 2xl:px-20 py-8 lg:py-16">
                    <div className="max-w-7xl mx-auto flex flex-col gap-12 sm:gap-16 lg:gap-24">
                        {blocs.map((bloc, index) => (
                            <div
                                key={bloc.titre}
                                className={`flex flex-col-reverse items-center gap-8 sm:gap-8 lg:gap-14 ${index % 2 === 1 ? "lg:flex-row-reverse" : "lg:flex-row"
                                    }`}
                            >
                                {/* Image */}
                                {/* Cadre comme la maquette : image entière (hauteur auto, jamais coupée) */}
                                <div className="relative w-full lg:w-1/2">
                                    {/* halo violet derrière */}
                                    <div className="pointer-events-none absolute -inset-4 sm:-inset-6 rounded-[2rem] bg-violet-700/20 blur-3xl" />
                                    <div className="relative rounded-[20px] sm:rounded-[28px] border border-white/10 bg-zinc-900 p-[7px] sm:p-[10px] shadow-[0_28px_80px_rgba(91,33,182,0.25)] overflow-hidden">
                                        <img
                                            src={bloc.img}
                                            alt={bloc.titre}
                                            loading="lazy"
                                            className="block w-full h-auto rounded-[15px] sm:rounded-[21px]"
                                        />
                                    </div>
                                </div>

                                {/* Texte */}
                                <div className="w-full lg:w-1/2 flex flex-col gap-3 sm:gap-5">
                                    <h2 className="font-archivo text-xl sm:text-3xl lg:text-4xl leading-tight">
                                        {bloc.titre}
                                    </h2>
                                    <p className="text-sm sm:text-base lg:text-lg text-white/75 leading-relaxed">
                                        {bloc.texte}
                                    </p>
                                    <ul className="flex flex-col gap-1.5 sm:gap-2">
                                        {bloc.points.map((p) => (
                                            <li key={p} className="flex items-start gap-1 text-violet-300 text-sm sm:text-base lg:text-lg">
                                                <BsDot size={22} className="flex-shrink-0 -mt-0.5 sm:mt-0.5" />
                                                <span>{p}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* ==================================================
                    2 quater. PAIEMENTS SÉCURISÉS — vous êtes payé, garanti
                ================================================== */}

                <section className="w-full px-4 sm:px-8 2xl:px-20 py-10 sm:py-16 lg:py-20">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12">
                            <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.15em] text-violet-400 mb-3">
                                Paiements sécurisés par Stripe
                            </p>
                            <h2 className="font-archivo text-2xl sm:text-3xl lg:text-4xl leading-tight">
                                Vos recettes vous reviennent. <span className="text-violet-400">Garanti.</span>
                            </h2>
                            <p className="text-sm sm:text-base lg:text-lg text-white/75 leading-relaxed mt-3 sm:mt-4">
                                L'argent de vos billets est géré par Stripe Connect, la solution de paiement
                                utilisée par les plateformes du monde entier. Thrundrz ne garde jamais vos
                                recettes : nous prenons uniquement un pourcentage, puis votre part vous est versée.
                            </p>
                        </div>

                        {/* 4 étapes */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
                            {etapesPaiement.map(({ icon: Icon, titre, texte }, i) => (
                                <div
                                    key={titre}
                                    className="relative rounded-xl sm:rounded-2xl bg-zinc-900 border border-white/5 hover:border-violet-500/40 transition p-5 lg:p-6"
                                >
                                    <span className="absolute top-4 right-5 text-3xl font-archivo text-white/10">
                                        {i + 1}
                                    </span>
                                    <div className="w-11 h-11 rounded-full bg-violet-600/20 text-violet-400 flex items-center justify-center mb-4">
                                        <Icon className="w-5 h-5" />
                                    </div>
                                    <h3 className="text-base sm:text-lg font-semibold text-white mb-2">{titre}</h3>
                                    <p className="text-sm text-white/70 leading-relaxed">{texte}</p>
                                </div>
                            ))}
                        </div>

                        {/* Garanties + remboursements */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mt-4 sm:mt-6">
                            <div className="rounded-xl sm:rounded-2xl border border-violet-500/40 bg-violet-600/10 p-5 sm:p-7">
                                <h3 className="font-archivo text-lg sm:text-xl mb-3">Ce qui vous protège</h3>
                                <ul className="flex flex-col gap-1.5 sm:gap-2">
                                    {garantiesPaiement.map((g) => (
                                        <li key={g} className="flex items-start gap-1 text-sm sm:text-base text-violet-200">
                                            <BsDot size={22} className="flex-shrink-0 -mt-0.5" />
                                            <span>{g}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="rounded-xl sm:rounded-2xl bg-zinc-900 border border-white/5 p-5 sm:p-7">
                                <h3 className="flex items-center gap-2 font-archivo text-lg sm:text-xl mb-3">
                                    <FaUndoAlt className="w-4 h-4 text-violet-400" /> Remboursements et annulations
                                </h3>
                                <p className="text-sm sm:text-base text-white/75 leading-relaxed">
                                    Si vous annulez votre événement, les acheteurs sont remboursés à 100 %.
                                    Un acheteur peut aussi annuler lui-même jusqu'à 24 h avant l'événement :
                                    il est alors remboursé du prix de son billet, hors frais de service et de paiement. Le délai avant versement protège tout le monde,
                                    car l'argent est encore chez Stripe. Les règles complètes sont dans nos{" "}
                                    <a href="/conditions-generales#billetterie-organisateurs" className="text-violet-300 underline hover:text-violet-200">
                                        conditions générales
                                    </a>
                                    , notre{" "}
                                    <a href="/politique-confidentialite" className="text-violet-300 underline hover:text-violet-200">
                                        politique de confidentialité
                                    </a>{" "}
                                    et nos{" "}
                                    <a href="/mentions-legales#paiements" className="text-violet-300 underline hover:text-violet-200">
                                        mentions légales
                                    </a>
                                    .
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ==================================================
                    2 ter. ÉVÉNEMENTS PUBLIÉS SUR THRUNDRZ
                ================================================== */}

                <EventsHome />

                {/* ==================================================
                    2 bis. QUESTIONS TARIFS → CONTACT
                ================================================== */}

                <section className="w-full px-4 py-8 sm:py-10">
                    <div className="max-w-3xl mx-auto rounded-2xl border border-violet-500/40 bg-violet-600/10 p-5 sm:p-8 text-center">
                        <h3 className="font-archivo text-lg sm:text-xl lg:text-2xl mb-2 sm:mb-3">
                            Des questions sur nos tarifs ?
                        </h3>
                        <p className="text-sm sm:text-base text-white/75 leading-relaxed mb-4 sm:mb-5">
                            Notre équipe vous présente les conditions de la billetterie
                            et répond à toutes vos questions.
                        </p>
                        <a
                            href="#contact"
                            className={`${btnBase} inline-block bg-violet-600 hover:bg-violet-700 text-white`}
                        >
                            Contactez-nous
                        </a>
                    </div>
                </section>

                {/* ==================================================
                    3. BANDEAU CTA
                ================================================== */}

                <section className="w-full bg-gradient-to-r from-[#481699] via-violet-800 to-[#481699] px-4 py-10 sm:py-16 lg:py-20 mt-6 sm:mt-10">
                    <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-4 sm:gap-6">
                        <h2 className="font-archivo text-2xl sm:text-3xl lg:text-4xl leading-tight">
                            Lancez votre premier événement sur Thrundrz
                        </h2>
                        <p className="text-sm sm:text-base lg:text-lg text-white/90 leading-relaxed">
                            Créez votre espace créateur en quelques minutes. Besoin d'un coup de main
                            pour démarrer ? Notre équipe vous accompagne pour publier votre premier
                            événement et configurer votre billetterie.
                        </p>
                        <div className={btnGroup}>
                            <a
                                href="/devenir-partenaire#login"
                                className={`${btnBase} bg-white text-[#481699] hover:bg-white/90`}
                            >
                                Publier un événement
                            </a>
                            <a
                                href="#contact"
                                className={`${btnBase} border border-white/60 hover:bg-white/10`}
                            >
                                Contactez-nous
                            </a>
                        </div>

                    </div>

                </section>
                <SectionDon />

                {/* ==================================================
                    4. BARRE D'AVANTAGES (icônes)
                ================================================== */}

                <section className="w-full px-4 py-10 sm:py-16 lg:py-20 border-b border-white/10">
                    <div className="max-w-6xl mx-auto">
                        <h2 className="font-archivo text-center text-2xl sm:text-3xl lg:text-4xl leading-tight mb-8 sm:mb-12">
                            Gérer vos événements n'a jamais été aussi simple
                        </h2>
                        <div className="grid grid-cols-2 md:grid-cols-5 gap-x-4 gap-y-6 sm:gap-8">
                            {avantages.map(({ icon: Icon, label }) => (
                                <div key={label} className="flex flex-col items-center gap-2 sm:gap-3 text-center">
                                    <div className="w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-violet-600/20 text-violet-400 flex items-center justify-center">
                                        <Icon className="w-5 h-5 sm:w-6 sm:h-6" />
                                    </div>
                                    <span className="text-sm sm:text-base font-medium">{label}</span>
                                </div>
                            ))}
                        </div>

                        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mt-8 sm:mt-12">
                            <a
                                href="https://play.google.com/store/apps/details?id=fr.thrundrz.even.thrundrz&pcampaignid=web_share"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 bg-zinc-900 hover:bg-violet-700 px-3 sm:px-4 py-2 rounded-lg text-sm sm:text-base font-semibold transition"
                            >
                                <FaGooglePlay className="w-4 h-4 sm:w-[18px] sm:h-[18px]" />
                                <span>Play Store</span>
                            </a>
                            <a
                                href="https://apps.apple.com/us/app/thrundrz/id6756219738"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 bg-zinc-900 hover:bg-violet-700 px-3 sm:px-4 py-2 rounded-lg text-sm sm:text-base font-semibold transition"
                            >
                                <FaApple className="w-4 h-4 sm:w-[18px] sm:h-[18px]" />
                                <span>App Store</span>
                            </a>
                        </div>
                    </div>
                </section>

                {/* ==================================================
                    5. FAQ
                ================================================== */}

                <section className="w-full px-4 py-10 sm:py-16 lg:py-20">
                    <div className="max-w-6xl mx-auto">
                        <h2 className="font-archivo text-center text-2xl sm:text-3xl lg:text-4xl leading-tight mb-8 sm:mb-12">
                            Besoin d'aide ? <span className="text-violet-400">On a les réponses</span>
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                            {faq.map(({ q, r }) => (
                                <div
                                    key={q}
                                    className="rounded-xl sm:rounded-2xl bg-zinc-900 border border-white/5 hover:border-violet-500/40 transition p-5 lg:p-8 text-left sm:text-center"
                                >
                                    <h3 className="text-base sm:text-xl lg:text-2xl font-semibold text-violet-300 mb-2 sm:mb-3">{q}</h3>
                                    <p className="text-sm sm:text-base text-white/75 leading-relaxed">{r}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ==================================================
                    6. CONTACT — texte gauche / formulaire droite
                ================================================== */}

                <section id="contact" className="w-full scroll-mt-24 bg-gradient-to-t from-[#1a0838] to-black px-4 sm:px-8 2xl:px-20 py-10 sm:py-16 lg:py-24">
                    <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
                        {/* Texte */}
                        <div className="w-full lg:w-1/2 flex flex-col gap-3 sm:gap-5">
                            <h2 className="font-archivo text-2xl sm:text-3xl lg:text-4xl leading-tight">Nous sommes là pour vous</h2>
                            <p className="text-sm sm:text-base lg:text-lg text-white/80 leading-relaxed">
                                Une question sur la billetterie, les QR codes ou la publication de vos
                                événements ? Besoin d'une démonstration ? Remplissez le formulaire et
                                nous revenons vers vous pour vous guider pas à pas.
                            </p>
                            <ul className="flex flex-col gap-1.5 sm:gap-2">
                                {[
                                    "Nous sommes disponibles pour répondre à toutes vos questions",
                                    "Démonstration de l'espace créateur",
                                    "Aide à la mise en place de votre billetterie",
                                    "Support et suivi personnalisé",
                                ].map((p) => (
                                    <li key={p} className="flex items-start gap-1 text-sm sm:text-base lg:text-lg">
                                        <BsDot size={22} className="text-violet-400 flex-shrink-0 -mt-0.5 sm:mt-0.5" />
                                        <span>{p}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Formulaire */}
                        <div className="w-full lg:w-1/2 bg-white rounded-xl sm:rounded-2xl p-4 sm:p-8 shadow-2xl shadow-violet-900/40">
                            <form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:gap-4">
                                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                                    <div className="relative w-full">
                                        <IoPerson className="absolute left-3 top-1/2 -translate-y-1/2 text-violet-500" size={18} />
                                        <input name="nom" value={form.nom} onChange={handleChange} placeholder="Nom" required className={inputClass} />
                                    </div>
                                    <div className="relative w-full">
                                        <IoPerson className="absolute left-3 top-1/2 -translate-y-1/2 text-violet-500" size={18} />
                                        <input name="prenom" value={form.prenom} onChange={handleChange} placeholder="Prénom" required className={inputClass} />
                                    </div>
                                </div>

                                <div className="relative w-full">
                                    <IoMailSharp className="absolute left-3 top-1/2 -translate-y-1/2 text-violet-500" size={18} />
                                    <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email" required className={inputClass} />
                                </div>

                                <textarea
                                    name="message"
                                    value={form.message}
                                    onChange={handleChange}
                                    placeholder="Votre message"
                                    required
                                    className="w-full px-4 py-3 text-base sm:text-sm text-black bg-white h-32 sm:h-36 resize-none rounded-lg border border-violet-300 focus:border-violet-600 focus:ring-violet-600 outline-none placeholder:text-violet-400"
                                />

                                <div className="flex justify-center">
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className={`${btnBase} bg-violet-600 text-white ${isLoading ? "opacity-70 cursor-not-allowed" : "hover:bg-violet-700"
                                            }`}
                                    >
                                        {isLoading ? "Envoi en cours..." : "Envoyer"}
                                    </button>
                                </div>

                                {/* Mention obligatoire quand le badge reCAPTCHA est masqué */}
                                <p className="text-[11px] sm:text-xs text-gray-500 text-center leading-snug">
                                    Ce site est protégé par reCAPTCHA. Les{" "}
                                    <a
                                        href="https://policies.google.com/privacy"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="underline hover:text-violet-600"
                                    >
                                        règles de confidentialité
                                    </a>{" "}
                                    et les{" "}
                                    <a
                                        href="https://policies.google.com/terms"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="underline hover:text-violet-600"
                                    >
                                        conditions d'utilisation
                                    </a>{" "}
                                    de Google s'appliquent.
                                </p>
                            </form>
                        </div>
                    </div>
                    <ToastContainer />
                </section>
            </main>

            <Footer />
            <ChatbotIcon />
        </>
    );
};

export default MindHome;